import React, { useState } from "react";
import { FormInput, Provider } from '@fluentui/react-northstar';
import { EyeIcon, EyeSlashIcon } from "@fluentui/react-icons-northstar";

const PasswordTextInput = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const iconContents = ({
        content: showPassword ? (<EyeSlashIcon />) : (<EyeIcon />),
        onClick: () => onClickIcon()
    });

    const onClickIcon = () => {
        setShowPassword(!showPassword);
    }

    return (
        <Provider.Consumer
            render={(theme) => (
                <FormInput
                    data-testid="passwordInput"
                    type={showPassword ? "text" : "password"}
                    className={theme.siteVariables.themeString === "default"
                        ? "passwordInputText default" : "passwordInputText dark"}
                    icon={iconContents}
                    errorIndicator={iconContents}
                    {...props} />
            )}
        ></Provider.Consumer >
    );
};

export default PasswordTextInput;